// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".refresh-button[data-v-d0146968]{background-color:#fff;position:sticky;left:0;bottom:0}", ""]);
// Exports
module.exports = exports;
